module.exports = __webpack_public_path__ + "img/GS_Profile-Jack Sauls.4ef9ad87.png";